import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FetchSettingsBidItemDetailsRequest } from '../../../../../../../core/projects.actions';
import { settingsBidItemDetails } from '../../../../../../../core/projects.selectors';

@Component({
  standalone: false,
  selector: 'app-bid-item-side-nav-wrapper',
  templateUrl: './bid-item-side-nav-wrapper.component.html',
  styleUrls: ['./bid-item-side-nav-wrapper.component.scss'],
})
export class BidItemSideNavWrapperComponent implements OnInit, OnDestroy {
  @Input() data: any;

  bidItemDetails: any = {};

  private readonly onDestroy = new Subject<void>();

  constructor(private store: Store) {}

  headersList: { id: number; label: string }[] = [];
  selectedTabId = 0;
  selectedTabLabel: string | null = null;

  private readonly headersListSource: { id: number; label: string }[] = [
    { id: 0, label: 'Details' },
    { id: 2, label: 'Fields' },
    { id: 5, label: 'Site qty' },
    { id: 6, label: 'Geometry' },
  ];

  ngOnInit(): void {
    this.headersList = [...this.headersListSource];

    if (this.data?.id) {
      const qp = {
        include: [
          { headings: ['alignment'] },
          'rollup_field',
          'fields',
          'site_quantities',
        ],
      };
      this.store.dispatch(FetchSettingsBidItemDetailsRequest({ bidItemId: this.data.id, qp }));
    }
    this.store.select(settingsBidItemDetails(this.data?.id))
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.bidItemDetails = data ?? {};
      });
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  selectHeader(header: { id: number; label: string }): void {
    this.selectedTabId = header.id;
    this.selectedTabLabel = null;
  }

  selectMenu(header: { id: number; label: string }): void {
    this.selectedTabId = header.id;
    this.selectedTabLabel = header.label;
  }
}
